var noop = function () { return null; };
export default noop;
//# sourceMappingURL=noop.js.map